import React, { Fragment, useEffect, useState } from 'react';
import {
  Row,
  Col,
  Card,
  FormGroup,
  CardBody,
  Button,
  Input,
  Spinner,
  Label,
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import IntlMessages from '../../../../../helpers/IntlMessages';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
} from '../../../../../helpers/AxiosAPI';
import {
  API_External_Source,
  gPI_Farehourbor_Integration_Items,
  gAPI_Users_By_Id,
} from '../../../../../constants/APIs';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import sync_farehourbor from '../../../../../assets/sync_farehourbor.png';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import Select from 'react-select';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
const FarehourborForm = ({
  propertyId,
  email,
  locale,
  submit,
  LoadData,
  farehourborData,
  farehourborIntegration,
}) => {
  const [open, setOpen] = useState(false);
  const [isloading, setIsLoading] = useState(true);
  const [msg, setMsg] = useState([]);
  const [configurations, setConfigurations] = useState([]);
  const [sourceData, setSourceData] = useState({
    groupId: getGroupID(),
    propertyId: propertyId,
    createdBy: 'Admin',
    sourceStatus: 'Active',
    sourceType: 'Farehourbor',
    name: 'FareHarbor Sync',
    frequency: 'Weekly',
    webPages: [],
    faqList: [],
    farehourborConfiguration: [],
    enableFAQ: false,
    email: email,
  });
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (farehourborData?.id) {
      AxiosAPI({
        method: 'get',
        url: `${API_External_Source}/${farehourborData?.id}`,
      }).then((res) => {
        const data = res.data;
        if (data.faqList === null) data.faqList = [];

        AxiosAPI({
          method: 'get',
          url: `${gPI_Farehourbor_Integration_Items}/${
            farehourborIntegration?.id
          }?group_id=${getGroupID()}`,
        }).then((result) => {
          setItems(
            result.data.map((m) => ({ label: m.name, key: m.id, value: m.id }))
          );
          if (
            res.data.farehourborConfiguration !== undefined &&
            res.data.farehourborConfiguration !== null &&
            res.data.farehourborConfiguration.length > 0
          ) {
            let configList = [];
            res.data.farehourborConfiguration.map((m) => {
              // eslint-disable-next-line array-callback-return
              let optionsList = [];
              result.data.map((d) => {
                if (m?.items.filter((f) => f == d.id).length > 0)
                  optionsList.push({ label: d.name, key: d.id, value: d.id });
              });
              configList.push(optionsList);
            });

            setConfigurations(configList);
            setSourceData({
              ...data,
              name: 'FareHarbor Sync',
              groupId: getGroupID(),
              propertyId: propertyId,
              createdBy: 'Admin',
              email: email,
            });
            setIsLoading(false);
          }
        });
      });
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gPI_Farehourbor_Integration_Items}/${
          farehourborIntegration?.id
        }?group_id=${getGroupID()}`,
      }).then((res) => {
        setItems(
          res.data.map((m) => ({ label: m.name, key: m.id, value: m.id }))
        );
        setIsLoading(false);
      });
    }
  }, [propertyId, farehourborData]);

  const handleFarehourborCategory = (e, index) => {
    let configuration = [...sourceData.farehourborConfiguration];
    configuration[index][e.target.name] = e.target.value;
    setSourceData({ ...sourceData, farehourborConfiguration: configuration });
  };

  const handleChange = (e) => {
    setSourceData({ ...sourceData, [e.target.name]: e.target.value });
  };

  const handleSyncManualy = (item) => {
    handleSync(item);
  };

  const handleAddConfiguration = () => {
    let lst = [...sourceData.farehourborConfiguration];
    lst.push({ category: '', items: [] });
    let configList = [...configurations];
    configList.push([]);
    setConfigurations(configList);
    setSourceData({ ...sourceData, farehourborConfiguration: lst });
  };

  const handleRemoveConfiguration = (val) => {
    let lst = [...sourceData.farehourborConfiguration];
    lst = lst.filter((f, index) => index !== val);
    let configList = [...configurations];
    configList = configList.filter((f, index) => index !== val);
    setConfigurations(configList);
    setSourceData({ ...sourceData, farehourborConfiguration: lst });
  };

  const handleSync = (item) => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    }).then((res) => {
      AxiosAPI({
        method: 'put',
        url: `${API_External_Source}/${item.id}`,
        data: {
          userName: res.data.fullName,
          isManual: true,
          email: email,
        },
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          NotificationManager.success(
            '',
            'We have received your request. It will take few minutes.',
            3000,
            null,
            null,
            'success'
          );
          LoadData();
        }
      });
    });
  };

  const handleSave = () => {
    const data = {
      ...sourceData,
      name: 'FareHarbor Sync',
      groupId: getGroupID(),
      propertyId: propertyId,
      createdBy: 'Admin',
      email: email,
    };

    if (sourceData?.id) {
      AxiosAPI({
        method: 'put',
        url: `${API_External_Source}/${sourceData.id}`,
        data: data,
      })
        .then((res) => {
          NotificationManager.success('Updated successfully', '', 3000);
          LoadData();
        })
        .catch((err) => {
          NotificationManager.error('Update failed', '', 3000);
          console.error(err);
        });
    } else {
      console.log(JSON.stringify(sourceData));
      submit(sourceData);
    }
  };

  const handleFarehourborItems = (options, index) => {
    let config = [...configurations];
    config[index] = options;
    console.log(config, configurations, options);
    setConfigurations(config);
    let lst = [...sourceData.farehourborConfiguration];
    lst[index].items = options.map((i) => i.value);
    setSourceData({ ...sourceData, farehourborConfiguration: lst });
  };

  return (
    <Fragment>
      <Colxx xxs="12">
        <Card style={{ width: '100%', borderRadius: '1.25rem' }}>
          {isloading ? (
            <div className="loading" />
          ) : (
            <CardBody>
              <Col md="12" className="mt-2 mb-3">
                <img
                  src={sync_farehourbor}
                  // style={{ width: '100%', height: '90px' }}
                ></img>
              </Col>
              <Col md="12" className="mt-2 mb-3">
                <Row>
                  {/* <Colxx sm={4} className="mb-3">
                    <Label>
                      <IntlMessages id='dashboards.title' /> <span style={{ color: 'red' }}> *</span>
                    </Label>
                    <Input
                      value={sourceData.name}
                      name="name"
                      onChange={handleChange}
                      disabled
                    ></Input>
                  </Colxx> */}
                  <Colxx sm={4} className="mb-3">
                    <Label>
                      <IntlMessages id="pages.status" />{' '}
                      <span style={{ color: 'red' }}> *</span>
                    </Label>
                    <Input
                      type="select"
                      value={sourceData.status}
                      name="status"
                      onChange={handleChange}
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </Input>
                  </Colxx>
                  <Colxx sm={5} className="mb-3">
                    <Label>
                      <IntlMessages id="dashboards.frequency" />{' '}
                      <span style={{ color: 'red' }}> *</span>
                    </Label>
                    <Input
                      type="select"
                      value={sourceData.frequency}
                      name="frequency"
                      onChange={handleChange}
                    >
                      {/* <option value="Daily">Daily</option> */}
                      <option value="Weekly">Weekly</option>
                      <option value="Monthly">Monthly</option>
                      <option value="Manually">Manually</option>
                    </Input>
                  </Colxx>
                </Row>

                <p className="mb-2">
                  With integration to <b>FareHarbor</b>, you can sync{' '}
                  <b>item descriptions</b> from FareHarbor directly into your AI
                  Assistant on a set schedule. This ensures your AI has the most
                  up-to-date information to assist users.
                </p>
              </Col>
              <Row className="ml-1">
                <Colxx sm={12} className="mb-1">
                  <FormGroup>
                    {sourceData?.farehourborConfiguration &&
                      sourceData.farehourborConfiguration.map((m, index) => (
                        <Fragment>
                          <Row>
                            <Colxx sm={3} className="mb-1">
                              <Label for="webPages">
                                <IntlMessages id="dashboards.category" />
                                <span style={{ color: 'red' }}> *</span>
                              </Label>
                            </Colxx>
                            <Colxx sm={6} className="mb-1">
                              <Label for="webPages">Items</Label>
                            </Colxx>
                          </Row>
                          <Row className="mb-1">
                            <Colxx sm={3} className="mb-2">
                              <Input
                                value={m.category}
                                name="category"
                                onChange={(e) =>
                                  handleFarehourborCategory(e, index)
                                }
                              ></Input>
                            </Colxx>
                            <Colxx sm={6} className="mb-2">
                              <Select
                                components={{ Input: CustomSelectInput }}
                                className="react-select"
                                classNamePrefix="react-select"
                                name="form-field-name"
                                placeholder="Select Items"
                                isMulti={true}
                                options={items}
                                value={configurations[index]}
                                onChange={(val) =>
                                  handleFarehourborItems(val, index)
                                }
                              />
                            </Colxx>
                            <Colxx sm={2} className="mb-2">
                              <Button
                                outline
                                size="xs"
                                color="danger"
                                onClick={() => handleRemoveConfiguration(index)}
                              >
                                X
                              </Button>
                            </Colxx>
                          </Row>
                        </Fragment>
                      ))}
                  </FormGroup>
                </Colxx>
              </Row>
              <Row className="ml-1">
                <Colxx md={5} className="mb-3">
                  <Button
                    outline
                    color="primary"
                    size="xs"
                    onClick={() => handleAddConfiguration()}
                  >
                    <IntlMessages id="dashboards.addItem" />
                  </Button>
                </Colxx>
              </Row>
              <Row className="ml-1">
                <Col md={12} className="mb-3 text-end">
                  <Button
                    color="primary"
                    size="sm"
                    onClick={() => handleSyncManualy(sourceData)}
                  >
                    <IntlMessages id="dashboards.sync" />
                  </Button>
                  <Button
                    color="secondary"
                    onClick={handleSave}
                    size="sm"
                    className="ml-3"
                  >
                    <span className="label">
                      <IntlMessages id="dashboards.save" />
                    </span>
                  </Button>
                </Col>
              </Row>
              <Row></Row>
            </CardBody>
          )}
        </Card>
      </Colxx>
    </Fragment>
  );
};
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, email } = settings;
  return {
    propertyId,
    locale,
    email,
  };
};

export default injectIntl(connect(mapStateToProps, {})(FarehourborForm));
